import LegalPage from "./LegalPage";

export default function PrivacyPolicy() {
    return (
        <LegalPage title="Privacy Policy">
            <p><strong>Titolare del trattamento:</strong> FitMama — Amanda Morani — Amanda.morani@hotmail.com</p>
            <p>La presente informativa descrive le modalità con cui vengono trattati i dati personali degli utenti che visitano il sito.</p>
            <h2 className="font-serif text-2xl text-ink mt-8">Dati raccolti</h2>
            <p>Raccogliamo esclusivamente i dati che ci fornisci volontariamente (es. indirizzo email tramite il modulo newsletter) e dati tecnici anonimi di navigazione.</p>
            <h2 className="font-serif text-2xl text-ink mt-8">Finalità</h2>
            <p>I dati vengono utilizzati per rispondere a richieste, inviare comunicazioni di marketing (solo con consenso esplicito) e per finalità statistiche.</p>
            <h2 className="font-serif text-2xl text-ink mt-8">Diritti dell&apos;interessato</h2>
            <p>Puoi accedere, rettificare o cancellare i tuoi dati scrivendo a Amanda.morani@hotmail.com in qualsiasi momento.</p>
            <p className="text-sm italic mt-10">Ultimo aggiornamento: dicembre 2025.</p>
        </LegalPage>
    );
}
